import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';

//Servicios

//Modelos

//Componentes
import Spinner from '../../components/spinner/Spinner';
import NewDJMV from './NewDJMV';

function NewDJMVContainer() {
    const { toast, token, grapesVariety } = useGlobalContext();
    const Navigate = useNavigate();
    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [DJMVData, setDJMVData] = useState();

    const FormMethods = useForm();

    useEffect(() => {
        // async function fetchDJMV() {
        //     try {
        //         setLoader(true);
        //         //Obtenemos la DJMV segun el id de los params
        //         const DJMV = await DJMVService.single({
        //             token,
        //             id: parseInt(Params.id),
        //         });
        //         if (DJMV) {
        //             //Establecemos los datos para la nueva DJMV
        //             const newDJMV = new NewDJCPModel({
        //                 cabecera: DJMV.data.cabecera,
        //                 items: DJMV.data.items,
        //             });
        //             setDJMVData(newDJMV);
        //             setTableData(buildTableData(newDJMV.items));
        //             //Establecemos los valores iniciales del form
        //             let formValues = {};
        //             DJMV.data.items.forEach((it, i) => {
        //                 formValues[`kilos` + i] = it.kilos;
        //             });
        //             FormMethods.reset(formValues);
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //         return err;
        //     }
        // }
        // fetchDJMV();
    }, []);

    const onSubmit = async (data) => {
        try {
            setLoader(true);
            //Formacion del objeto para enviar en la peticion
            let formItems = { ...DJMVData };
            formItems.items.forEach((it, i) => {
                it.kilos = parseInt(data[`kilos` + i]);
            });

            //Peticion para actualizar la DJMV
            // const UpdateDJCMV = await DJMVService.update({
            //     token,
            //     declaracion: formItems,
            // });

            // //Si la respuesta es correcta, navegamos denuevo a la tabla de DJMVs y desplegamos mensaje de éxito
            // if (UpdateDJCMV) {
            //     Navigate(RoutesApp.Declaraciones.transferenciaViniedo);
            //     toast('DJMV enviada con éxito', { type: 'success' });
            // }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            console.log(err);
            return err;
        }
    };

    /**Funcion que crea el objeto para pasarle a la tabla que lista las DJMVs */
    const buildTableData = (
        data = [
            { id: 0, variedad: 0, superficie: 0, kilos: 0, id_declaracion: 0 },
        ]
    ) => {
        return {
            headers: ['Variedad de Uva', 'Superficie', 'Kilos Probables'],
            pagination: 10,
            data: data?.map((dj, i) => {
                return {
                    variedad: grapesVariety?.find(
                        (gv) => gv.codigo === dj.variedad
                    )?.variedad,
                    superficie: `${dj.superficie} m²`,
                    kilos: (
                        <input
                            {...FormMethods.register('kilos' + i)}
                            type={'number'}
                        />
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? (
        <Spinner />
    ) : (
        <NewDJMV
            functions={{
                ...FormMethods,
                onSubmit,
            }}
            states={{ tableData, DJMVData }}
        />
    );
}

export default NewDJMVContainer;
